






import Vue from "vue"
import CardList from "~/components/guideline/cardList/CardList.vue"

export default Vue.extend({
  components: {
    CardList,
  },
})
